import script from "./JobListTableComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./JobListTableComponent.vue?vue&type=script&setup=true&lang=js"

import "./JobListTableComponent.vue?vue&type=style&index=0&id=c00ca34a&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c00ca34a"]])

export default __exports__